import { useState } from 'react';
import classNames from 'node_modules/classnames/index';
import { GlobalCfeLoader } from 'src/components/WidgetMaker/WidgetDnD/GlobalCfeLoader';
import { useWidgetDndContextData } from 'src/context/WidgetDndContext';
import { useLoadVisibleReel } from '../../hooks/useLoadVisibleReel';
import { Tooltip } from '@mui/material';
import { getMobileOperatingSystem, OS_ENUMS } from 'src/utils/operatingSystem';

const InstagramVideoComp = (props: any) => {
  const { oneGridCellGeometry, post, index, videoRef } = props;
  const [loadVideo, setLoadVideo] = useState(false);
  const [isVideoDownloaded, setIsVideoDownloaded] = useState(false);
  const isIOS = getMobileOperatingSystem() === OS_ENUMS.ios;
  const source = loadVideo ? isIOS ? `${post}#t=0.001` : post : undefined
  // const [shouldMuteVideo, setShouldMuteVideo] = useState(true);
  useLoadVisibleReel({ videoRef, reelIndex: index, setLoadVideo, loadVideo });
  const {
    widgetContextState: { globalStyle },
  } = useWidgetDndContextData();

  const handleMouseEnter = () => {
    videoRef?.[index]?.play();
  };

  const handleMouseLeave = () => {
    videoRef?.[index]?.pause();
    videoRef[index].currentTime = 0;
  };

  return (
    <div className="tw-relative">
      {!isVideoDownloaded && (
        <div className="tw-absolute tw-left-1/2 tw-top-1/2 tw-z-[4] -tw-translate-x-1/2 -tw-translate-y-1/2">
          <GlobalCfeLoader
            type={globalStyle?.appLoader?.loaderId || 'ellipsis'}
            color={globalStyle?.appLoader?.color}
          />
        </div>
      )}
      <Tooltip title={'Click to see full video'}>
        <video
          ref={(node) => (videoRef[index] = node)}
          style={{
            width: oneGridCellGeometry.width + 'px',
            height: oneGridCellGeometry.height + 'px',
            minWidth: oneGridCellGeometry.width + 'px',
          }}
          className={classNames('tw-h-full tw-w-full tw-bg-black tw-object-cover')}
          loop
          playsInline={true}
          muted={true}
          onLoadedData={() => setIsVideoDownloaded(true)}
          src={source}
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
        />
      </Tooltip>
    </div>
  );
};

export default InstagramVideoComp;
